module.exports = __webpack_public_path__ + "img/multitela.f388e86e.png";